// schema.ts
export type RelationType = "one-to-many" | "many-to-one";

export interface TableRelation {
  table: string;
  localField: string;
  foreignField: string;
  type: RelationType;
}

export interface TableSchema {
  name: string;
  fields: string[];
  relations?: TableRelation[];
}


export const schema: Record<string, TableSchema> = {
  municipios: {
    name: "municipios",
    fields: [
      "id_municipio",
      "codigo_ine",
      "nombre",
      "codigo_provincia",
      "created_at",
    ],
  },

  calidades_forestales: {
    name: "calidades_forestales",
    fields: [
      "id",
      "id_municipio",
      "codigo_especie",
      "calidad_estacion",
      "volumen_medio",
      "descripcion",
      "created_at",
    ],
    relations: [
      {
        table: "especies",
        localField: "codigo_especie",
        foreignField: "codigo_especie",
        type: "many-to-one",
      },
      {
        table: "municipios",
        localField: "id_municipio",
        foreignField: "id_municipio",
        type: "many-to-one",
      },
    ],
  },

  especies: {
    name: "especies",
    fields: [
      "codigo_especie",
      "nombre_comun",
      "nombre_cientifico",
      "tipo_vegetacion",
      "descripcion",
      "created_at",
    ],
    relations: [
      {
        table: "calidades_forestales",
        localField: "codigo_especie",
        foreignField: "codigo_especie",
        type: "one-to-many",
      },
      {
        table: "existencias_forestales",
        localField: "codigo_especie",
        foreignField: "codigo_especie",
        type: "one-to-many",
      },
      {
        table: "inventarios_ifn2",
        localField: "codigo_especie",
        foreignField: "codigo_especie",
        type: "one-to-many",
      },
      {
        table: "inventarios_ifn3",
        localField: "codigo_especie",
        foreignField: "codigo_especie",
        type: "one-to-many",
      },
    ],
  },

  existencias_forestales: {
    name: "existencias_forestales",
    fields: [
      "id",
      "id_municipio",
      "codigo_especie",
      "clase_diametrica",
      "num_pies",
      "area_basal",
      "volumen_corteza",
      "volumen_sin_corteza",
      "incremento_anual",
      "volumen_lena",
      "biomasa_aerea",
      "biomasa_raiz",
      "carbono_aereo",
      "carbono_raiz",
      "created_at",
    ],
    relations: [
      {
        table: "especies",
        localField: "codigo_especie",
        foreignField: "codigo_especie",
        type: "many-to-one",
      },
      {
        table: "municipios",
        localField: "id_municipio",
        foreignField: "id_municipio",
        type: "many-to-one",
      },
    ],
  },

  formaciones_municipales: {
    name: "formaciones_municipales",
    fields: [
      "id",
      "id_municipio",
      "codigo_formacion",
      "nombre_formacion",
      "area_hectareas",
      "porcentaje_cobertura",
      "estrato_ifn",
      "created_at",
    ],
    relations: [
      {
        table: "formaciones_vegetales",
        localField: "codigo_formacion",
        foreignField: "codigo_formacion",
        type: "many-to-one",
      },
      {
        table: "municipios",
        localField: "id_municipio",
        foreignField: "id_municipio",
        type: "many-to-one",
      },
    ],
  },
  propiedades_forestales: {
  name: "propiedades_forestales",
  fields: [
    "id",
    "id_municipio", 
    "tipo_propiedad",
    "categoria",
    "superficie_hectareas",
    "datos_adicionales",
    "created_at",
    "tipo_administracion",
    "titular",
    "numero_monte"
  ],
  relations: [
    {
      table: "municipios",
      localField: "id_municipio",
      foreignField: "id_municipio",
      type: "many-to-one",
    },
  ],
},
modelos_combustible: {
  name: "modelos_combustible",
  fields: [
    "id_municipio",
    "modelo_combustible", 
    "riesgo_incendio",
    "superficie_hectareas",
    "descripcion",
    "created_at",
  ],
  relations: [
    {
      table: "municipios",
      localField: "id_municipio",
      foreignField: "id_municipio",
      type: "many-to-one",
    },
  ],
},

  formaciones_vegetales: {
    name: "formaciones_vegetales",
    fields: [
      "codigo_formacion",
      "nombre",
      "tipo",
      "descripcion",
      "created_at",
    ],
    relations: [
      {
        table: "formaciones_municipales",
        localField: "codigo_formacion",
        foreignField: "codigo_formacion",
        type: "one-to-many",
      },
    ],
  },

  inventarios_ifn2: {
    name: "inventarios_ifn2",
    fields: [
      "id",
      "id_municipio",
      "codigo_especie",
      "clase_diametrica",
      "num_pies",
      "area_basal",
      "volumen_corteza",
      "volumen_sin_corteza",
      "volumen_lena",
      "periodo_inicio",
      "periodo_fin",
      "created_at",
    ],
    relations: [
      {
        table: "especies",
        localField: "codigo_especie",
        foreignField: "codigo_especie",
        type: "many-to-one",
      },
      {
        table: "municipios",
        localField: "id_municipio",
        foreignField: "id_municipio",
        type: "many-to-one",
      },
    ],
  },

  inventarios_ifn3: {
    name: "inventarios_ifn3",
    fields: [
      "id",
      "id_municipio",
      "codigo_especie",
      "clase_diametrica",
      "num_pies",
      "area_basal",
      "volumen_corteza",
      "volumen_sin_corteza",
      "volumen_lena",
      "periodo_inicio",
      "periodo_fin",
      "created_at",
    ],
    relations: [
      {
        table: "especies",
        localField: "codigo_especie",
        foreignField: "codigo_especie",
        type: "many-to-one",
      },
      {
        table: "municipios",
        localField: "id_municipio",
        foreignField: "id_municipio",
        type: "many-to-one",
      },
    ],
  },

  valoraciones_economicas: {
    name: "valoraciones_economicas",
    fields: [
      "id",
      "id_municipio",
      "formacion_arbolada",
      "area_hectareas",
      "valor_alimentos",
      "valor_madera",
      "valor_lena",
      "valor_pastos",
      "valor_agua",
      "valor_recreativo",
      "valor_caza",
      "valor_sedimentacion",
      "valor_carbono_suelo",
      "valor_carbono_arbolado",
      "valor_carbono_matorral",
      "valor_biodiversidad",
      "created_at",
    ],
    relations: [
      {
        table: "municipios",
        localField: "id_municipio",
        foreignField: "id_municipio",
        type: "many-to-one",
      },
    ],
  },

  "ckan_data_generic[datos_de_directorio_de_industrias_culturales]": {
    name: "ckan_data_generic[datos_de_directorio_de_industrias_culturales]",
    fields: [
      "Nombre del Organismo",
      "Descripción",
      "DatosPersonales",
      "Dirección",
      "Calle",
      "CodigoPostal",
      "Localidad",
      "Localidad-1",
      "SoloClasificar",
      "Teléfono",
      "Telefax oficial",
      "Fax",
      "e-mail",
      "Páginas de internet",
      "Latitud",
      "Longitud",
      "Información adicional",
      "Directorio Superior",
      "Identificador Directorio Superior",
      "Identificador",
      "actualizacionMetadatos",
      "Enlace al contenido",
      "Geolocalización"
    ],
    relations: []
  },
  "ckan_data_generic[datos_de_poblacion_total_por_provincias_y_sexo]": {
    name: "ckan_data_generic[datos_de_poblacion_total_por_provincias_y_sexo]",
    fields: [
      "FECHA",
      "SEXO",
      "PROVINCIA", 
      "POBLACIÓN"
    ],
    relations: []
  },
 "ckan_data_generic[actividad_inspectora_en_los_mataderos]": {
    name: "ckan_data_generic[actividad_inspectora_en_los_mataderos]",
    fields: [
      "Año",
      "Provincia",
      "Nº animales sacrificados en los mataderos de Castilla y León por cabeza - Ungulado",
      "Nº animales sacrificados en los mataderos de Castilla y León por cabeza - Ungulad",
      "Nº animales sacrificados en los mataderos de Castilla y León por cabeza - Ungulados",
      "Nº animales sacrificados en los mataderos de Castilla y León por cabeza - Ungulados-1",
      "Nº animales sacrificados en los mataderos de Castilla y León por cabeza - Ungulados",
      "Nº animales sacrificados en los mataderos de Castilla y León por cabeza - Aves",
      "Nº animales sacrificados en los mataderos de Castilla y León por cabeza - Lagomorfos",
      "Nº de sacrificios en los mataderos de Castilla y León en UGM - Ungulado",
      "Nº de sacrificios en los mataderos de Castilla y León en UGM - Ungulad",
      "Nº de sacrificios en los mataderos de Castilla y León en UGM - Ungulados",
      "Nº de sacrificios en los mataderos de Castilla y León en UGM - Ungulados-1",
      "Nº de sacrificios en los mataderos de Castilla y León en UGM - Ungulados",
      "Nº de sacrificios en los mataderos de Castilla y León en UGM - Aves",
      "Nº de sacrificios en los mataderos de Castilla y León en UGM - Lagomorfos"
    ],
    relations: []
  },
"ckan_data_generic[asociaciones_de_pacientes]": {
  name: "ckan_data_generic[asociaciones_de_pacientes]",
  fields: [
    "PATOLOGÍA",
    "ASOCIACIÓN",
    "PROVINCIA",
    "LOCALIDAD",
    "DIRECCIÓN",
    "TELÉFONO",
    "CORREO ELECTRÓNICO",
    "WEB",
    "N REGISTRO OFICIAL"
  ],
  relations: []
},
"ckan_data_generic[cartera_de_servicios_de_atencion_primaria]": {
  name: "ckan_data_generic[cartera_de_servicios_de_atencion_primaria]",
  fields: [
    "SERVICIOS",
    "TIPO DE POBLACIÓN"
  ],
  relations: []
},
"ckan_data_generic[datos_de_explotaciones_acuicolas]": {
  name: "ckan_data_generic[datos_de_explotaciones_acuicolas]",
  fields: [
    "Provincia",
    "SALMÓN DEL DANUBIO (HUCHO HUCHO)",
    "TRUCHA ARCO IRIS (ONCORHYNCHUS MYKISS)",
    "TRUCHA COMÚN (SALMO TRUTTA)",
    "LANGOSTINO BLANCO (LITOPENAEUS VANNAMEI)",
    "AÑO"
  ],
  relations: []
},
"ckan_data_generic[datos_de_censo_de_superficies_agrarias_en_castilla_y_leon]": {
  name: "ckan_data_generic[datos_de_censo_de_superficies_agrarias_en_castilla_y_leon]",
  fields: [
    "AÑOS",
    "PROVINCIAS",
    "SUP. TOT. DE LAS EXPLOTACIONES AGRARIAS (HA.)",
    "SUP. TOT. DE T. LABRADAS DE REGADÍO (HA.)",
    "SUP. TOT. EN T. LABRADAS (HA.)",
    "SUP. TOT. EN T. LABRADAS DE SECANO (HA.)",
    "SUPERFICIE AGRÍCOLA UTILIZADA (SAU) DE LAS EXPLOTACIONES AGRA"
  ],
  relations: []
},
"ckan_data_generic[datos_de_hosteleria_con_entrega_a_domicilio]": {
  name: "ckan_data_generic[datos_de_hosteleria_con_entrega_a_domicilio]",
  fields: [
    "Provincia",
    "Localidad",
    "Dirección",
    "Nombre comercial",
    "Número de Registro de Turismo de Castilla y León",
    "Tipología",
    "Recoger",
    "Envío",
    "Teléfono",
    "Correo electrónico",
    "Pagina web",
    "Observaciones",
    "Ubicación"
  ],
  relations: []
},
"ckan_data_generic[datos_de_licencias_de_caza_y_pesca]": {
  name: "ckan_data_generic[datos_de_licencias_de_caza_y_pesca]",
  fields: [
    "Año",
    "A",
    "A (Exentas)",
    "B",
    "B (Exentas)",
    "C",
    "IC",
    "TOTAL CAZA",
    "P1",
    "P1 (Exenta)",
    "P1 (Infantil)",
    "IP",
    "TOTAL PESCA",
    "TOTAL CAZA Y PESCA",
    "Personas licencia caza",
    "Personas licencia pesca",
    "Total personas con licencia caza y pesca"
  ],
  relations: []
},
"ckan_data_generic[datos_de_licitacion_de_obras_publicas]": {
  name: "ckan_data_generic[datos_de_licitacion_de_obras_publicas]",
  fields: [
    "Periodo",
    "Por organismos - total (miles de €)",
    "Edificación - vivienda (miles de €)",
    "Edificación - total (miles de €)",
    "Obra civil - total (miles de €)"
  ],
  relations: []
},
"ckan_data_generic[datos_de_numero_de_defunciones_en_castilla_y_leon]": {
  name: "ckan_data_generic[datos_de_numero_de_defunciones_en_castilla_y_leon]",
  fields: [
    "Año",
    "Provincia",
    "Defunciones"
  ],
  relations: []
},
"ckan_data_generic[datos_de_numero_de_matrimonios_en_castilla_y_leon]": {
  name: "ckan_data_generic[datos_de_numero_de_matrimonios_en_castilla_y_leon]",
  fields: [
    "Año",
    "Provincia",
    "Número de matrimonios de distino sexo"
  ],
  relations: []
},
"ckan_data_generic[datos_de_numero_de_nacimientos_en_castilla_y_leon]": {
  name: "ckan_data_generic[datos_de_numero_de_nacimientos_en_castilla_y_leon]",
  fields: [
    "Año",
    "Provincia",
    "Valor"
  ],
  relations: []
},
"ckan_data_generic[datos_de_red_de_circuitos_escenicos]": {
  name: "ckan_data_generic[datos_de_red_de_circuitos_escenicos]",
  fields: [
    "Provincia",
    "Entidad local",
    "Localidad",
    "Dirección",
    "C. P.",
    "Teléfono",
    "Correo e.",
    "Localidad-1",
    "Programa en 2023",
    "Espacio escénico",
    "Dirección espacio escénico",
    "479"
  ],
  relations: []
},
"ckan_data_generic[datos_de_red_de_teatros]": {
  name: "ckan_data_generic[datos_de_red_de_teatros]",
  fields: [
    "Entidad",
    "Sala",
    "Dirección",
    "CP",
    "Provincia",
    "Municipio",
    "Responsables",
    "Teléfono/s",
    "FAX",
    "email",
    "Dirección WEB",
    "Coordenadas"
  ],
  relations: []
},
"ckan_data_generic[datos_de_registro_de_agentes_de_cooperacion_para_el_desarrollo_de_castilla_y_leon]": {
  name: "ckan_data_generic[datos_de_registro_de_agentes_de_cooperacion_para_el_desarrollo_de_castilla_y_leon]",
  fields: [
    "NOMBRE",
    "CIF",
    "F. REGISTRO",
    "DIRECCIÓN",
    "POBLACIÓN",
    "PROVINCIA",
    "TELÉFONO",
    "Nº.REGISTRO",
    "E-MAIL",
    "Column 10",
    "Column 11",
    "Column 12",
    "Column 13",
    "Código Postal"
  ],
  relations: []
},
"ckan_data_generic[datos_de_registro_de_artesanos_alimentarios]": {
  name: "ckan_data_generic[datos_de_registro_de_artesanos_alimentarios]",
  fields: [
    "Subcategoria",
    "Código EAA",
    "Nombre y apellidos/Razón Social",
    "Domicilio industrial",
    "Municipio",
    "Provincia",
    "Web",
    "prov"
  ],
  relations: []
},
"ckan_data_generic[datos_de_terrenos_cinegeticos]": {
  name: "ckan_data_generic[datos_de_terrenos_cinegeticos]",
  fields: [
    "Año",
    "Provincia",
    "Tipo",
    "Número",
    "Hectáreas",
    "provincia_abreviado"
  ],
  relations: []
},
"ckan_data_generic[directorio_de_asociaciones_de_consumidores]": {
  name: "ckan_data_generic[directorio_de_asociaciones_de_consumidores]",
  fields: [
    "Nombre del Organismo",
    "Descripción",
    "DatosPersonales",
    "Dirección",
    "Calle",
    "CodigoPostal",
    "Localidad",
    "Localidad-1",
    "SoloClasificar",
    "Teléfono",
    "Telefax oficial",
    "Fax",
    "e-mail",
    "Páginas de internet",
    "Posicion",
    "Información adicional",
    "Directorio Superior",
    "Identificador Directorio Superior",
    "Identificador",
    "actualizacionMetadatos",
    "Enlace al contenido",
    "cabecera_faltante1"
  ],
  relations: []
},
"ckan_data_generic[directorio_de_talleres_artesanos_de_castilla_y_leon]": {
  name: "ckan_data_generic[directorio_de_talleres_artesanos_de_castilla_y_leon]",
  fields: [
    "Nº REGISTRO",
    "RAZÓN SOCIAL",
    "NOMBRE COMERCIAL",
    "DIRECCIÓN",
    "C.P.",
    "MUNICIPIO",
    "LOCALIDAD",
    "PROVINCIA",
    "TELEFONO",
    "TELEFONO 2",
    "ACTIVIDAD - SUBSECTOR - MODALIDAD (PRINCIPAL)",
    "ACTIVIDAD - SUBSECTOR - MODALIDAD (SECUNDARIO)"
  ],
  relations: []
},
"ckan_data_generic[directorio_de_talleres_artesanos_de_cyl]": {
  name: "ckan_data_generic[directorio_de_talleres_artesanos_de_cyl]",
  fields: [
    "Nº REGISTRO",
    "RAZÓN SOCIAL",
    "NOMBRE COMERCIAL",
    "DIRECCIÓN",
    "C.P.",
    "MUNICIPIO",
    "LOCALIDAD",
    "PROVINCIA",
    "TELEFONO",
    "TELEFONO 2",
    "ACTIVIDAD - SUBSECTOR - MODALIDAD (PRINCIPAL)",
    "ACTIVIDAD - SUBSECTOR - MODALIDAD (SECUNDARIO)"
  ],
  relations: []
},
"ckan_data_generic[edificaciones_y_construcciones_-_geometria_punto_110000]": {
  name: "ckan_data_generic[edificaciones_y_construcciones_-_geometria_punto_110000]",
  fields: [
  ],
  relations: []
},
"ckan_data_generic[empresas_de_trabajo_forestales]": {
  name: "ckan_data_generic[empresas_de_trabajo_forestales]",
  fields: [
      "Nombre",
      "Direccion",
      "Municipio",
      "Provincia",
      "Actividad",
      "Certificación FSC",
      "Certificación PEFC"
  ],
  relations: []
},
"ckan_data_generic[entidades_asociativas_agroalimentarias_prioritarias_de_caracter_regional]": {
  name: "ckan_data_generic[entidades_asociativas_agroalimentarias_prioritarias_de_caracter_regional]",
  fields: [
      "N� DE REGISTRO EAPr",
      "NOMBRE DE LA ENTIDAD",
      "LOCALIDAD",
      "PROVINCIA",
      "NIF",
      "FECHA DE RECONOCIMIENTO"
  ],
  relations: []
},  
"ckan_data_generic[grupos_de_accion_local]": {
  name: "ckan_data_generic[grupos_de_accion_local]",
  fields: [
      "NOMBRE",
      "cabecera_faltante1",
      "DIRECCION",
      "MUNICIPIO",
      "CP",
      "PROVINCIA",
      "TELÉFONO",
      "email",
      "web"
  ],
  relations: []
}, 
};

type Join = {
  table: string;
  on: {
    localField: string;
    foreignField: string;
  };
};

type Filter = {
  field: string;
  operator: "=" | ">" | "<" | ">=" | "<=" | "ILIKE";
  value: string;
};

export type QueryBuilderProps = {
  onSaveConfig?: (config: QueryBuilderConfig, sql?: any) => void;
  onSaveSql?: (sql: string) => void;
  onSaved?: () => void;
  initialConfig?: QueryBuilderConfig;
  initialSql?: string;
};

export interface QueryBuilderConfig {
  baseTable: string;
  selectedFields: string[];
  joins: Join[];
  filters: Filter[];
  groupByFields?: any[];
  sql?: string;
  /** Texto crudo de ORDER BY para reconstruir la consulta (ej: `SUM(t.x) DESC`) */
  orderByRaw?: string;
  limit: number;
  offset: number;
  /** Cada ítem puede incluir `innerSql` si SUM/AVG/… aplica sobre una expresión (no solo una columna). */
  agreggation: any[];
  /** Alias por campo: el valor mostrado en tablas/gráficos en lugar del nombre del campo */
  fieldAliases?: Record<string, string>;
  /**
   * Expresiones SQL para columnas calculadas (ids `__computed_expr_*`), p. ej. CONCAT(municipios.nombre, ' - ', valoraciones_economicas.formacion_arbolada).
   * Debe coincidir con `aggregateConfig[field].innerSql` en el builder.
   */
  computedColumnExpressions?: Record<string, string>;
}